import { IonContent, IonPage, useIonViewDidEnter } from '@ionic/react'
import { useDispatch, useSelector } from 'react-redux'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import HeaderNav from '../../../components/headerNav/HeaderNav.component'
import { useHistory } from 'react-router'
import { TabConstants } from '../../../components/tabs/Tabs.constants'
import { savePickupAddress, setPickupAddressDefaults } from '../store/pickupAddress.actions'
import PCRHeader from '../../../components/pcrHeader/PCRHeader.component'
import RefRecAddress from '../../../components/address/RefRecAddress.component'
import { showAlert } from '../../../components/alert/store/alert.actions'
import { getZipSelector } from '../../../components/zip/selectors/zip.selector'
import { IPickupAddressState } from '../store/pickupAddress.types'
import { getPickupAddressSelector } from '../selectors'

const PickupAddress: React.FC = () => {
  const history = useHistory()
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const zip = useSelector(getZipSelector)
  const { alertMessage } = zip
  const { __areDefaultsSet }: IPickupAddressState = useSelector(getPickupAddressSelector)

  const onBackClick = () => {
    history.push(TabConstants.CHART_ROUTE)
  }

  const onSaveClick = () => {
    dispatch(savePickupAddress())
  }

  useIonViewDidEnter(() => {
    if (!__areDefaultsSet) {
      dispatch(setPickupAddressDefaults(true))
    }
  }, [__areDefaultsSet])

  useEffect(() => {
    if (alertMessage) {
      dispatch(showAlert({ message: alertMessage }))
    }
  }, [dispatch, alertMessage])

  return (
    <IonPage id='PickupAddressPage'>
      <PCRHeader />
      <HeaderNav
        prevOnClick={onBackClick}
        prevLabel={t('common.buttons.Back')}
        isBackButton={true}
        nextLabel={t('common.buttons.Save')}
        nextOnClick={onSaveClick}
        title='Pickup Address'
      />
      <IonContent color='light'>
        <RefRecAddress isPHI addressTypeSelected={1} />
      </IonContent>
    </IonPage>
  )
}

export default PickupAddress
